import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Team.css';

const TeamCard = ({ member }) => {
    const categoriesList = member.categories
        ? member.categories.split(',').map(c => c.trim()).filter(Boolean)
        : [];

    return (
        <motion.div
            className="team-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ y: -6 }}
            transition={{ duration: 0.3 }}
        >
            <div className="card-content">
                <div className="avatar-wrapper">
                    <div className="avatar-glow"></div>
                    <img
                        src={member.avatarUrl || 'https://cdn.discordapp.com/embed/avatars/0.png'}
                        alt={member.username || member.displayName}
                        className="team-avatar"
                        onError={(e) => { e.target.src = 'https://cdn.discordapp.com/embed/avatars/0.png'; }}
                    />
                </div>

                <div className="info-wrapper">
                    <h3 className="display-name">{member.displayName}</h3>
                    {member.description && (
                        <span className="aka-name">{member.description}</span>
                    )}
                    <p className="username">@{member.username}</p>
                    <div className="divider"></div>
                </div>

                {categoriesList.length > 0 && (
                    <div className="associated-teams-container">
                        <span className="teams-label">ASSOCIATED TEAMS</span>
                        <div className="teams-tags-list">
                            {categoriesList.map((cat, index) => (
                                <span key={index} className="team-role-tag">
                                    {cat}
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default TeamCard;
